import NidApp from './api.js';
import ncsColor from 'ncs-color';

(function ($, nordsjo) {
  $(function () {
    var $sizeSelect = $(document.getElementById('pa_storlek')),
      $varInput = $(document.getElementById('nid_variation_id')),
      $varACCcode = $('input[name=acc-code]'),
      $varNCSCode = $('input[name=ncs-code]'),
      $varQuantity = $('input[name=quantity]'),
      $prodAttrHeader = $(document.getElementById('prod-attribute-header')),
      $optionsHeader = $('.options-header'),
      $variationDropDown = $(document.getElementById('product-attr-dropdown'));

    function getProductVariationData() {
      return $('form.variations_form').data('product_variations');
    }

    function setProductSku(sku) {
      $prodAttrHeader.find('span').text(sku);
    }

    function getProductVarId() {
      return +$varInput.val();
    }

    function getAccCode() {
      return $varACCcode.val();
    }

    function getNCSCode() {
      return $varNCSCode.val();
    }

    function getQuantity() {
      return $varQuantity.val();
    }

    function getActiveVariation(varId) {
      var varData = getProductVariationData();
      return _.find(varData, function (data) {
        return data.variation_id == varId;
      });
    }

    function isValidForShoppingList() {
      var valid = true;
      var valid_colour = false;
      var variationData = getProductVariationData();

      if ('undefined' !== typeof variationData) {
        if (isNaN(getProductVarId()) || 0 === getProductVarId()) {
          valid = false;
        }
      }
      if ($varACCcode.length > 0) {
        if ('' !== getAccCode()) {
          valid_colour = true;
        }
      }
      if ($varNCSCode.length > 0) {
        if ('' !== getNCSCode()) {
          valid_colour = true;
        }
      }
      if ($varNCSCode.length == 0) {
        valid_colour = true;
      }
      if (true === valid && true === valid_colour) {
        return true;
      } else {
        return false;
      }
    }

    function validateProductForShoppingList() {
      var $wishListButton = $('#add-to-wishlist');
      var $quantityDiv = $('.woocommerce-quantity');

      $wishListButton.attr('disabled', true);
      $quantityDiv.hide();
      if (isValidForShoppingList()) {
        $wishListButton.attr('disabled', false);
        $quantityDiv.show();
      }
    }

    $(document).ready(function () {
      if ($('body').hasClass('single-product')) {
        validateProductForShoppingList();
      }
    });

    /** Bind the various events to the respective functions for the products view. */
    $('.site')
      .on('click', 'button.wishlist-button', NidApp.addProductToCart)
      .on(
        'click',
        'button.moodboard-button, button.bb-moodboard-link',
        NidApp.addItemToMoodboard
      );

    $('body')
      .on('mouseenter', 'a.has-popup', function (e) {
        var $this = $(this);
        if ($this.hasClass('visible')) return;

        $this.find('span').fadeIn(100);
      })
      .on('mouseleave', 'a.has-popup', function (e) {
        var $this = $(this);
        if ($this.hasClass('visible')) return;

        $this.find('span').fadeOut(50);
      })
      .on('click', 'button.store-popup', function (e) {
        e.preventDefault();

        nordsjo.showStorePicker('contact-store');
      });

    $variationDropDown.on('change', 'input', function (e) {
      var $this = $(this),
        val = $this.val(),
        variationID = $this.attr('id'),
        varId = getProductVarId(),
        prodVar,
        variationName;

      prodVar = getActiveVariation(varId);
      variationName = $("label[for='" + variationID + "']").text();
      $('button.add-to-wishlist').attr('data-variation-name', variationName);

      if (typeof prodVar !== 'undefined') {
        setProductSku(prodVar.sku);
      }

      $sizeSelect.val(val).trigger('change');
      $this
        .closest('.options-container')
        .find('.options-header')
        .text($this.next().text())
        .trigger('click');
    });

    $varInput.on('change', function (e) {
      $('button.add-to-wishlist').attr('data-variation-id', $(this).val());
      validateProductForShoppingList();
    });

    $varACCcode.on('change', function (e) {
      validateProductForShoppingList();
    });

    $('.is-decrease').on('click', function (e) {
      var $quantity = $('.qty').val();
      $quantity--;
      $('button.add-to-wishlist').attr('data-quantity', $quantity);
    });

    $('.is-increase').on('click', function (e) {
      var $quantity = $('.qty').val();
      $quantity++;
      $('button.add-to-wishlist').attr('data-quantity', $quantity);
    });

    $('#unbroken').on('change', function (e) {
      var $this = $(e.target);
      var checked = $this.prop('checked');
      var $colorPickerButton = $('#product-colour-picker');
      var $colorSwatch = $('.colour-picker-product .colour_swatch');
      var $wishlistButton = $('#add-to-wishlist');
      var $quantity = $('.qty').val();

      if (true === checked) {
        $varACCcode.val(nordsjo.tUnbroken);
        $colorPickerButton.attr('disabled', true);
        $colorSwatch
          .find('.swatch')
          .css('border', '1px solid #eee')
          .css('background', 'white')
          .show();
        $colorSwatch
          .find('.name')
          .html(nordsjo.tUnbrokenWhite)
          .show();
        $wishlistButton
          .attr('data-acc-code', '')
          .attr('data-rgb', 'rgb(255, 255, 255)')
          .attr('data-colour-name', nordsjo.tUnbrokenWhite)
          .attr('data-quantity', $quantity);
      } else {
        $varACCcode.val('');
        $colorPickerButton.attr('disabled', false);
        $colorSwatch
          .find('.swatch')
          .css('border', '0')
          .hide();
        $colorSwatch
          .find('.name')
          .html('')
          .hide();
        $wishlistButton
          .attr('data-acc-code', '')
          .attr('data-rgb', '')
          .attr('data-colour-name', '')
          .attr('data-quantity', $quantity);
      }
      validateProductForShoppingList();
    });


    $('.tab-wrapper .tab-nav .tab').on('click', function (e) {
        e.preventDefault();

        let divClass = $(this).attr('data-tab');

        const $tabContent = $(divClass) 

        // if element exists
        if ($($tabContent).length) {
          if($tabContent.hasClass('active')) {
            $tabContent.fadeOut().removeClass('active')
            $('.tab-wrapper .tab-nav .tab input').prop('checked', false);
            return;
          }

          $('.tab-wrapper .tab-nav .tab input').prop('checked', false);
          $('.tab-wrapper .tab-content .content').removeClass('active');

          $(this).find('input[type="checkbox"]').prop('checked', true);
          $tabContent.addClass('active');
        } 
    })

    $('.tab-wrapper .tab-nav-mobile').on('click', function (e) {
      e.preventDefault();
      var $tabContent = $(this).next();

      if($tabContent.hasClass('active')) {
        $tabContent.fadeOut().removeClass('active')
        $(this).removeClass('selected')
        $('.tab-wrapper .tab-nav .tab input').prop('checked', false);
        return;
      }

      $('.tab-wrapper .tab-nav-mobile').removeClass('selected');
      $('.tab-wrapper .tab-content .content').removeClass('active');
      $(this).addClass('selected')
      $tabContent.addClass('active');
    })

    $('#ncs-code').on('change', function (e) {
      var $this = $(e.target);
      var $unbroken = $('#unbroken');
      var $colorPickerButton = $('#product-colour-picker');
      var $colorSwatch = $('.colour-picker-product .colour_swatch');
      var $wishlistButton = $('#add-to-wishlist');
      var $quantity = $('.qty').val();

      if ($this.val()) {
        var RGB = ncsColor.hex('NCS ' + $this.val());

        $unbroken
          .attr('disabled', true)
          .parent()
          .attr('disabled', true);
        $colorPickerButton.attr('disabled', true);
        $colorSwatch.find('.swatch').hide();
        $colorSwatch.find('.name').html('');
        $wishlistButton
          .attr('data-ncs-code', $this.val())
          .attr('data-rgb', 'rgb(255, 255, 255)')
          .attr('data-colour-name', $this.val())
          .attr('data-quantity', $quantity);

        if (null !== RGB) {
          $colorSwatch
            .find('.swatch')
            .css('background', RGB)
            .show();
          $wishlistButton
            .attr('data-rgb', RGB)
            .attr('data-quantity', $quantity);
        }
      } else {
        $colorSwatch.find('.swatch').hide();
        $colorSwatch.find('.name').html('');
        $unbroken
          .attr('disabled', false)
          .parent()
          .attr('disabled', false);
        $colorPickerButton.attr('disabled', false);
      }

      validateProductForShoppingList();
    });

    $('.unbroken .button').on('click', function (e) {
      $(e.target)
        .find('#unbroken')
        .click();
    });

    /** Show/hide for product information */
    var $prodInfo = $('.product-extra-inner');

    if ($prodInfo.length) {
      $.each($prodInfo, function (i) {
        var $this = $(this),
          height = $this.outerHeight(),
          maxHeight = 600,
          minHeight = 400;

        if (height > maxHeight) {
          var $container, $toggle;

          $container = $('<div />', {
            class: 'toggle-container',
          });
          $toggle = $('<a />', {
            href: '#',
            text: nordsjo.readMore,
            class: 'button read-more',
          });

          $container.append($toggle);

          $toggle.on('click', function (e) {
            e.preventDefault();

            if ($this.hasClass('truncated')) {
              $this.animate({
                height: height
              }, 200, function () {
                $this.removeClass('truncated');
                $toggle.text(nordsjo.hide);
              });
            } else {
              $this.animate({
                height: minHeight
              }, 200, function () {
                $this.addClass('truncated');
                $toggle.text(nordsjo.readMore);
              });
            }
          });

          $this
            .addClass('truncated')
            .height(minHeight)
            .after($container);
        }
      });
    }

    $(document).ready(function () {
      var $selectedVariation = $('input:checked', $variationDropDown);
      var label = $selectedVariation.parent().text();
      var variationName = $(
        "label[for='" + $selectedVariation.attr('id') + "']"
      ).text();

      if ('undefined' !== typeof label) {
        $optionsHeader.html(label);
      }
      $('button.add-to-wishlist').attr('data-variation-name', variationName);
    });
  });
})(jQuery, nordsjo);
